document.addEventListener("DOMContentLoaded", () => {
   let slider = document.querySelector('.projects');

    if (slider) {
        let objectSlider = new ProjectSlider(slider);
        objectSlider.init();
    }
});


class ProjectSlider {
    constructor(slider) {
        this.slider = slider;
        this.items = slider.querySelectorAll('.project-item');
        this.wrap = slider.querySelector('.projects__wrap');
        this.itemsCount = this.items.length;
        this.index = 0;
        this.animate = false;
    }

    init() {
        this.items[0].classList.add('active');
        this.bindArrows();
    }

    slide(direction) {
        if (this.animate) {
            return;
        }
        this.animate = true;
        let activeItem = this.items[this.index];
        activeItem.classList.remove('active');
        if (direction === 'left') {
            this.index = (this.index - 1) < 0 ? this.itemsCount - 1 : (this.index - 1);
        } else if (direction === 'right') {
            this.index = (this.index + 1) > this.itemsCount - 1 ? 0 : (this.index + 1);
        }

        let nextItem = this.items[this.index];
        nextItem.classList.add('active');

        let that = this;
        this.wrap.style.left = (this.index * -100) + '%';
        setTimeout(function () {
            that.animate = false;
        }, 400);

    }

    bindArrows() {
        let buttons = this.slider.querySelectorAll('.buttons');
        buttons.forEach((buttonContainer) => {
            let leftArrow = buttonContainer.querySelector('.buttons__left');
            let rightArrow = buttonContainer.querySelector('.buttons__right');

            leftArrow.addEventListener('click', () => {
                this.slide('left');
            });
            rightArrow.addEventListener('click', () => {
                this.slide('right');
            });

        })
    }
}
